import { useUserStore } from '@/store/useUserStore'
import { getBranchFromPathUrl } from '@/utils/helpers/urlHelper'
import { useCallback } from 'react'

interface HavePermissionAccessProps {
  permission: string
  branch?: string
}
export const usePermissions = () => {
  const { rolesMe } = useUserStore()
  const havePermissionAccess = useCallback(
    ({ permission, branch }: HavePermissionAccessProps) => {
      const safeBranch = branch || getBranchFromPathUrl()
      const branchRoles = rolesMe
      const access = branchRoles.filter((el) => el.branchSlug === safeBranch)
      if (!safeBranch) {
        const allList = branchRoles.map((el) => el.permissions)
        return allList.some((el) => el.includes(permission))
      }
      return access.some((el) => el.permissions.includes(permission))
    },
    [rolesMe],
  )
  return {
    havePermissionAccess,
  }
}
